<template>
  <div>
    <div
        style="margin-top: 20px; color: rgb(0, 0, 0, 0.65);font-size: 15px;line-height: 35px ">
      <div v-if="type == 'normal'" style="">
        <p>
          <span class="title">购买产品：</span>
          <span v-if="order.product_type != 'TS200'">{{ order.product_type }}-{{ order.product_name }} <span
              style="color: #00adff;margin-left: 5px">{{ order.package_name }}</span></span>
          <span v-if="order.product_type == 'TS200'">{{ order.product_type }}-{{ order.position_name }} <span
              style="color: #00adff;margin-left: 5px">{{ order.bidding_enterprise_name }}</span></span>
        </p>
        <p >
          <span class="title">订单编号：</span>
          <span>{{ order.id }} </span>
        </p>
        <p v-if="order.activation_type == '1'">
          <span class="title">租赁时长：</span>
          <span>{{ order.activation_dura }}</span>
        </p>
        <p>
          <span class="title">订单类型：</span>
           <el-tag v-if="">{{ order.orderTypeName }}</el-tag>
        </p>
        <p>
          <span class="title">订单状态：</span>
           <el-tag v-if="">{{ order.orderStatusName }}</el-tag>
        </p>
        <p>
          <span class="title">支付金额：</span>
          <span style="color: red;font-weight: bold">{{ order.payment_amount }} 元 </span>
        </p>
        <p>
          <span class="title">创建时间：</span>
          <span>{{ order.ctm }} </span>
        </p>
      </div>
      <div v-if="type =='refund'">
        <el-row>
          <el-col :span="12">
            <p>
              <span class="title">订单编号：</span>
              <span>{{ refundOrder.id }} </span>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">原订单编号：</span>
              <span>{{ refundOrder.order_id }} </span>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">退单状态：</span>
              <el-tag>{{ refundOrder.approvalStatusName }}</el-tag>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">退单金额：</span>
              <span style="color: red;font-weight: bold">{{ refundOrder.refund_amount }} 元</span>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">退款方式：</span>
              <el-tag>{{ refundOrder.refundMethodName }}</el-tag>
            </p>
          </el-col>
          <el-col :span="12">
            <p>
              <span class="title">发起退单时间：</span>
              <span>{{ refundOrder.ctm }} </span>
            </p>
          </el-col>
          <el-col :span="24">
            <p>
              <span class="title">退单原因：</span>
              <span>{{ refundOrder.refund_reason }} </span>
            </p>
          </el-col>
          <el-col :span="24" v-if="['2','3'].includes(refundOrder.approval_status)">
            <p>
              <span class="title">审核备注：</span>
              <span>{{ refundOrder.approval_comment.length >0? refundOrder.approval_comment:'暂无'}} </span>
            </p>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="toos_layer_footer">
      <el-button type="primary" @click=" dialog.val = false;">关闭</el-button>
    </div>
  </div>

</template>

<script>
import orderCountdown from "@/components/common/orderCountdown";

export default {
  name: "detail",
  props: ["dialog", "orderId",'refundOrder'],
  components: {orderCountdown},
  data() {
    return {
      type:'normal',
      order: {},
      options2: [], //订单类型
      options3: [], //订单状态
      options9: [],//产品退款方式
      options10: [],//退单审核状态
    }
  },
  methods: {
    // 获取字典值
    async getDictsData(dict) {
      let options = [];
      await this.$tools
          .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
            data: {
              dictionary_code: dict,
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              options = res.data.data.dictionary_detail;
            } else {
              // this.$message({ type: "error", message: res.data.msg });
            }
          })
          .catch((err) => {
            // this.$message({ type: "error", message: err });
          });
      return options;
    },
    // 获取订单详情
    getOrderDetail() {
      this.$tools
          .asyncPost(this, this.$baseUrl.orderGet, {
            data: {
              id: this.orderId
            }
          }).then(res => {
        if (res.data.code == 0) {
          this.order = res.data.data
          this.options2.forEach(item=>{
            if(this.order.order_type == item.dictionary_key){
              this.order.orderTypeName = item.dictionary_value
            }
          })
          this.options3.forEach(item=>{
            if(this.order.status == item.dictionary_key){
              this.order.orderStatusName = item.dictionary_value
            }
          })
        }
      })
    },

    handleTimeout() {
      this.$message({type: "error", message: '订单已超时，请重新下单'});
      this.dialog.val = false;
    },
  },
  async mounted() {
    this.options2 =await this.getDictsData("PM-COMPANY-DDLX");
    this.options3 =await this.getDictsData("PM-COMPANY-DDZT");
    if(Object.keys(this.refundOrder).length >0 ){
      this.type='refund'
      this.options10 = await this.getDictsData("TDGL-SPZT");
      this.options9 =  await this.getDictsData("TDGL-TDFS");
      this.options10.forEach(item=>{
        if(this.refundOrder.approval_status == item.dictionary_key){
          this.refundOrder.approvalStatusName = item.dictionary_value
        }
      })
      this.options9.forEach(item=>{
        if(this.refundOrder.refund_method == item.dictionary_key){
          this.refundOrder.refundMethodName = item.dictionary_value
        }
      })
      this.$forceUpdate()
    }else{
      this.type='normal'
      this.getOrderDetail()
    }
  }
}
</script>

<style scoped>
.title {
  font-weight: bold;
}

.pro-item-intro {
  padding: 15px;
}

.pro-item-intros {
  color: rgb(0, 0, 0, 0.65);
  font-size: 13px;
  margin-left: 10px
}

.pay-method-unselect {
  cursor: pointer;
  color: rgb(0, 0, 0, 0.65)
}

.pay-method-select {
  color: #42A1FF;
  cursor: pointer;
}

.flex-al-center {
  display: flex;
  align-items: center;
}
</style>